import { render, staticRenderFns } from "./ComponentsPage.vue?vue&type=template&id=7f4d7db2&scoped=true&"
import script from "./ComponentsPage.vue?vue&type=script&lang=js&"
export * from "./ComponentsPage.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsPage.vue?vue&type=style&index=0&id=7f4d7db2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4d7db2",
  null
  
)

export default component.exports